require("style!css!less!./font-awesome-styles!./font-awesome.config.js");



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/font-awesome-webpack/0.0.4/font-awesome-webpack/index.js
 ** module id = 541
 ** module chunks = 0
 **/